import { Component, OnDestroy } from '@angular/core';
import { MatSliderChange, MatSliderDragEvent } from '@angular/material/slider';
import { combineLatest, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { StateManagerProjectService } from '@state-manager';
import { CornerstoneService } from '@viewer/cornerstone.service';
import {
  MAX_OPACITY,
  MIN_OPACITY,
  WINDOWS_WITHOUT_OPACITY,
} from './mask-opacity.data';

@Component({
  selector: 'app-mask-opacity',
  templateUrl: 'mask-opacity.component.html',
  styleUrls: ['mask-opacity.component.scss'],
})
export class MaskOpacityComponent implements OnDestroy {
  readonly windowsWithoutOpacity = WINDOWS_WITHOUT_OPACITY;
  readonly maxOpacity = MAX_OPACITY;
  readonly minOpacity = MIN_OPACITY;

  opacityMaskNumber: number;
  private _unsubscribe = new Subject();

  constructor(
    public stateManagerProjectService: StateManagerProjectService,
    public cornerstoneService: CornerstoneService
  ) {
    this.opacityMaskNumber = this.cornerstoneService.getMaskOpacityValue();

    combineLatest([
      this.cornerstoneService.isMaskOpacityValue(),
      this.stateManagerProjectService.currentSelectedWindow$,
      this.stateManagerProjectService.isActiveShowChangesMode$,
    ])
      .pipe(takeUntil(this._unsubscribe))
      .subscribe(([isMaskOpacityValue, currentSelectedWindow, showChanges]) => {
        this.opacityMaskNumber =
          showChanges === false ? isMaskOpacityValue : 50;
      });
  }

  changeMaskOpacity(event: MatSliderDragEvent): void {
    this.cornerstoneService.setMaskOpacity(event.value!);
  }

  ngOnDestroy(): void {
    this._unsubscribe.next(undefined);
    this._unsubscribe.complete();
  }

  isDisabled(): Observable<boolean> {
    return combineLatest([
      this.stateManagerProjectService.isViewerLoaded$,
      this.stateManagerProjectService.currentSelectedWindow$,
      this.stateManagerProjectService.isActiveShowChangesMode$,
    ]).pipe(
      map(
        ([isViewerLoaded, currentSelectedWindow, isActiveShowChangesMode]) => {
          return (
            !isViewerLoaded ||
            [0, 4].includes(currentSelectedWindow) ||
            isActiveShowChangesMode
          );
        }
      )
    );
  }
}
